'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _image_voucher = require('../../AccountManagement/image_voucher.jpg');

var _image_voucher2 = _interopRequireDefault(_image_voucher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherCard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherCard, _Component);

  function VoucherCard() {
    (0, _classCallCheck3.default)(this, VoucherCard);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherCard.__proto__ || (0, _getPrototypeOf2.default)(VoucherCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherCard, [{
    key: 'setVoucher',
    value: function setVoucher(item) {
      this.props.onSet(item);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Voucher.scss');
      var item = this.props.item;

      var coupon = item.coupon || null;
      return _react2.default.createElement(
        'div',
        { className: styles.voucherCard },
        _react2.default.createElement(
          'div',
          {
            className: styles.voucherCardImage,
            onClick: function onClick() {
              return _this2.setVoucher(item);
            }
          },
          _react2.default.createElement('img', { src: coupon.image || _image_voucher2.default, alt: 'image voucher' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.voucherCardInfo },
          _react2.default.createElement(
            'div',
            { className: styles.code },
            item.code
          ),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            coupon.title
          ),
          _react2.default.createElement(
            'div',
            { className: styles.link, onClick: function onClick() {
                return _this2.setVoucher(item);
              } },
            'T\xCCM HI\u1EC2U TH\xCAM'
          )
        )
      );
    }
  }]);
  return VoucherCard;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  onSet: _react.PropTypes.func
}, _temp);
exports.default = VoucherCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/VoucherCard.js
// module id = 1641
// module chunks = 0